export interface ConsumerBudgetOutputResponseDto {
	insights?: Insights
}

export interface Insights {
	automatedEvaluation?: AutomatedEvaluation
}

export interface AutomatedEvaluation {
	decision: AutomatedEvaluationEnum
	debtFactor?: AutomatedEvaluationRequirement
	disposableAmount: AutomatedEvaluationRequirement
	warningFlags: AutomatedEvaluationRequirement
	riskIndicatorFlags: AutomatedEvaluationRequirement
}

export interface AutomatedEvaluationRequirement {
	decision: AutomatedEvaluationEnum
	creditPolicyValue?: number
}

export enum AutomatedEvaluationEnum {
	WithinCreditPolicy = 'withinCreditPolicy',
	NotWithinCreditPolicy = 'notWithinCreditPolicy',
	ManualEvaluation = 'manualEvaluation',
}
